import { inject, Injectable, Signal } from '@angular/core';

import { Store } from '@ngrx/store';

import { LocationSelectors } from '@core/locations-data';
import { Location } from '@core/locations-types';

@Injectable({
  providedIn: 'root',
})
export class LocationsDataFacade {
  private readonly store = inject(Store);

  public get allLocations(): Signal<Location[]> {
    return this.store.selectSignal(LocationSelectors.entities());
  }
}
